import React from 'react';
import _ from 'lodash';

import { Typography } from '@occc-app/design-system';
import { ConstraintDaysOfWeekFragment, Weekday } from '@occc/graphql';

interface IDaysOfWeekProps {
  daysOfWeekConstraints: ConstraintDaysOfWeekFragment[];
}

const getDaysOfWeekString = (days: Weekday[]): string =>
  days.map((day) => _.capitalize(day)).join(', ');

export const DaysOfWeek: React.FC<IDaysOfWeekProps> = ({ daysOfWeekConstraints }) => {
  return (
    <>
      <Typography variant='body2' gutterBottom>
        Days of week
      </Typography>
      {daysOfWeekConstraints.map((item, index) => (
        <Typography key={index} gutterBottom>
          {getDaysOfWeekString(item.availableWeeklyOnDays)}
          <Typography variant='body2' display='inline' component='span'>
            {` (${item.startOfDayTimezone})`}
          </Typography>
        </Typography>
      ))}
    </>
  );
};
